import { render, staticRenderFns } from "./CustomsClue.vue?vue&type=template&id=54643a86&scoped=true&"
import script from "./CustomsClue.vue?vue&type=script&lang=js&"
export * from "./CustomsClue.vue?vue&type=script&lang=js&"
import style0 from "./CustomsClue.vue?vue&type=style&index=0&id=54643a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54643a86",
  null
  
)

export default component.exports